export class SsoConfig {
  public static SSO_CONF = {
    'issuer': 'ADP_SSO_ISSUER',
    'clientId': 'ADP_SSO_CLIENT_ID',
    'postLogoutRedirectUri': 'ADP_SSO_POST_LOGOUT_REDIRECT_URI',
    'redirectUri': window.location.origin,
    'responseType': 'code',
    'scope': 'ADP_SSO_SCOPE',
    'showDebugInformation': true
  }
}
